import { buildValidationSummaryGeneric } from '../../utils/validationUtils';
import { IMarkValidationByDocument } from '../../atoms/mark-validation-atoms';

// Build the validation summary array for a set of document ids
// Uses the generic utility function from validationUtils
export const buildMarkValidationSummaryByDocumentId = (
  documentIds: string[],
  validationData: any[]
): IMarkValidationByDocument[] => {
  const genericSummary = buildValidationSummaryGeneric(documentIds, validationData, false);

  // Map generic summary to mark-specific format
  return genericSummary.map((summary) => ({
    documentId: summary.entityId,
    hasValidationResponse: summary.hasValidationResponse,
    validationErrorsList: summary.validationErrorsList,
    validationErrorDetails: summary.validationErrorDetails.map((detail) => ({
      id: detail.id,
      field: detail.field,
      error: detail.error,
      errorDetail: detail.errorDetail,
      type: detail.type,
      dismissalReason: detail.dismissalReason,
    })),
  }));
};
